<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                loadForm: () => import('../forms/LoadForm'),
                fields: [
                    { type: 'autocomplete', text: 'Load', value: 'loadId', rules: [v => !!v || 'Load is required'], isRequired: true, form: () => import('./LoadForm'), apiMethod: 'Loads', claim: 'Loads' },
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'number', text: 'Number Of Hives', value: 'numberOfHives', rules: [v => (v !== null && v !== '') || 'Number Of Hives is required'], isRequired: true },
                    { type: 'number', text: 'Number Of Queenless Hives', value: 'numberOfQueenlessHives', rules: [v => (v !== null && v !== '') || 'Number Of Queenless Hives is required'], isRequired: true },
                    { type: 'number', text: 'Number Of Failing Hives', value: 'numberOfFailingHives', rules: [v => (v !== null && v !== '') || 'Number Of Failing Hives is required'], isRequired: true },
                    { type: 'number', text: 'Number Of Dead Hives', value: 'numberOfDeadHives', rules: [v => (v !== null && v !== '') || 'Number Of Dead Hives is required'], isRequired: true },
                    { type: 'checkbox', text: 'Is Sufficient Water', value: 'isSufficientWater', rules: [v => (v !== null && v !== '') || 'Is Sufficient Water is required'], isRequired: true },
                    { type: 'textarea', text: 'Comments', value: 'comments', rules: [v => !!v || 'Comments is required'], isRequired: true, maxLength: false },
                ],
                apiMethod: 'Inspections',
                formTitle: 'Inspection',
            }
        },
    };
</script>
